import { connect } from 'react-redux';

import { AsideBanners, IAsideBannersStoreProps } from './AsideBanners';
import { IState } from '../../store';

export function mapStateToProps(state: IState): IAsideBannersStoreProps {
  return {
    height: state.aside.height,
  };
}

export const AsideBannersContainer = connect<IAsideBannersStoreProps, {}, {}>(mapStateToProps)(AsideBanners);
